<template>
  <div>
    <van-popup v-model="showPopup" position="bottom" :close-on-click-overlay="true" @click-overlay="doClose"
      :safe-area-inset-bottom="false">
      <div class="ts_box" v-if="!isIos" @click="toDifComplaint(type)">
        <img :src="img" class="img" />
        <div class="text">{{ text }}</div>
      </div>
      <div class="ts_box1" v-else>
        <div class="item" @click="toDifComplaint(type)">
          <img :src='img' class="img" />
          <div class="text">投诉</div>
        </div>

        <div class="item" @click="$refs.remindPopup.open()">
          <img src="@/assets/image/share/pb.png" class="img" />
          <div class="text">屏蔽用户</div>
        </div>
      </div>
    </van-popup>
    <delcommentPop :open.sync="isDel"></delcommentPop>
    <remind-popup @onSuccess="$refs.remindPopup.close()" @onClose="toDifComplaint(11)" ref="remindPopup" title="屏蔽提示"
      text="屏蔽用户后，将自动解除关注关系，并将无法查看该用户发布的帖子和评论您可前往个人中心-设置内解除屏蔽" closeText="确认" onText="取消"></remind-popup>
  </div>
</template>

<script>
import delcommentPop from './delcomment-pop.vue'
export default {
  components: {
    delcommentPop
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'user'//user：投诉用户，comment：投诉评论，delComment：删除评论，delPost:删除帖子  
    },
    text: {
      type: String,
      default: '投诉用户'
    },
    img: {
      type: String,
      default:require('@/assets/image/homePage/tsyh.png')
    },
    customer_id: {
      type: [String, Number],
      default: '0'
    }
  },
  computed: {
    isIos() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent)
    }
  },
  data() {
    return {
      isDel: false,
      showPopup: false
    };
  },
  mounted() {
  },
  methods: {
    doOpen() {
      this.showPopup = true;
    },

    doClose() {
      this.showPopup = false;
      this.$emit('update:open', false);
    },
    //不同投诉
    toDifComplaint(type) {
      console.log(type);
      switch (type) {
        case 11:
          this.$toast('屏蔽用户成功')
          this.doClose()
          this.$refs.remindPopup.close()
          break
        case 'user':
          console.log(414);
          this.$nextTick(() => { this.doClose() })
          this.$router.push({
            path: '/pages/complaint/complaint',
            query: { target_id: this.customer_id, type: 3 }
          })
          break;
        case 'delComment':
          this.doClose()
          this.isDel = true

        default:
          break;
      }
    }
  },
  watch: {
    open(val) {
      if (val) {
        this.doOpen();
      }
    },
  },
}
</script>

<style lang="scss" scoped>
// ::v-deep .van-popup {
//   z-index: 1028 !important;
// }

.ts_box {
  width: 100%;
  padding: 0.75rem 0 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border-radius: 0.5rem 0.5rem 0 0;

  .img {
    display: block;
    width: 2.25rem;
    height: 2.25rem;
    margin-right: 0.65rem;
  }

  .text {
    font-size: 0.6rem;
    color: #666666;
  }
}

.ts_box1 {
  width: 100%;
  padding: 0.75rem 0 1rem;
  padding-left: 0.75rem;
  display: flex;
  background: #ffffff;
  border-radius: 0.5rem 0.5rem 0 0;

  .item {
    margin-left: 0.25rem;
    margin-right: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .img {
    display: block;
    width: 2.25rem;
    height: 2.25rem;
    margin-bottom: 0.35rem;
  }

  .text {
    font-size: 0.6rem;
    color: #666666;
  }
}
</style>